import 'css-chunksrc/client/common/zoneCreationForm/colorForm/styles.scss';export default {
  "colorForm": "_colorForm_10a72_1",
  "avatar": "_avatar_10a72_8",
  "colorPicker": "_colorPicker_10a72_12",
  "penIcon": "_penIcon_10a72_17",
  "icon": "_icon_10a72_28",
  "penIconHover": "_penIconHover_10a72_35",
  "visibility": "_visibility_10a72_42",
  "avatarWrapper": "_avatarWrapper_10a72_46",
  "avatarHover": "_avatarHover_10a72_50"
};